import config from '../config';
import ClientOAuth2 from 'client-oauth2';
import * as swaggerApi from '../../swagger/src/index'


class Oauth2Client {
    constructor(swaggerApi) {
        this.swaggerApi = swaggerApi;
        this.oauth2 = new ClientOAuth2({
            clientId: 'tools',
            clientSecret: '',
            accessTokenUri: '/api/login',
            authorizationUri: '',
            redirectUri: config.baseURL,
            scopes: ['read', 'write']
        });
        this.onChange();
    }

    login(email, password) {
        return this.oauth2.owner.getToken(email, password)
            .then(user => {
                localStorage.token = user.accessToken;
                this.onChange();
            })
            .catch(() => {
                // eslint-disable-next-line
                delete localStorage.token;
                this.onChange();
            });
    }

    parseToken(token) {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace('-', '+').replace('_', '/')
        return JSON.parse(window.atob(base64))
    }

    getUsername() {
        let token = this.getToken();
        let username = 'none';
        if (token) {  // Token is present
            if (token.split('.').length === 3) {  // Token with a valid JWT format XXX.YYY.ZZZ
                try { // Could be a valid JWT or an access token with the same format
                    username = this.parseToken(token).user_name;
                } catch (e) {
                    username = 'invalid';
                }
            }
            return username;  // Pass: All other tokens
        }
    }

    isAuthenticated() {
        let token = this.getToken();
        if (token) {  // Token is present
            if (token.split('.').length === 3) {  // Token with a valid JWT format XXX.YYY.ZZZ
                try { // Could be a valid JWT or an access token with the same format
                    let exp = this.parseToken(token).exp;
                    if (typeof exp === 'number') {  // JWT with an optonal expiration claims
                        return Math.round(new Date().getTime() / 1000) < exp;
                    }
                } catch (e) {
                    return true;  // Pass: Non-JWT token that looks like JWT
                }
            }
            return true;  // Pass: All other tokens
        }
        return false
    }

    getToken() {
        return localStorage.token;
    }

    logout(cb) {
        delete localStorage.token;
        if (cb) cb();
        this.onChange();
    }

    onChange() {
        if (this.isAuthenticated()) {
            this.swaggerApi.ApiClient.instance.authentications.spring_oauth.accessToken = localStorage.token;
        } else {
            this.swaggerApi.ApiClient.instance.authentications.spring_oauth.accessToken = null;
        }

    }
}

let Oauth2ClientPlugin = {
    install(Vue) {
        Vue.prototype.$oauth2 = new Oauth2Client(swaggerApi);
    }
};


export  default {
    Oauth2ClientPlugin,
    Oauth2Client: new Oauth2Client(swaggerApi)
};